/**************************************************
 * Nombre:       Barra_Servicios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import ic_bano from '../../../../Recursos/ic_bano.svg'
import ic_tv from '../../../../Recursos/ic_tv.svg'
import ic_wifi from '../../../../Recursos/ic_wifi.svg'
import ic_par from '../../../../Recursos/ic_par.svg'
import ic_res from '../../../../Recursos/ic_resta.svg'
import ic_aire from '../../../../Recursos/ic_aireaco.svg'
import {theme} from "../../../../Tema";


const Barra_Servicios = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: 'white',
                borderRadius: 4,
                boxShadow: 8,
                py: 3,
                pb: 3
            }}
        >

            {items.map((item, index) => {
                return (
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 6, sm: 4, md: 2}}
                        sx={{color: theme.palette.primary.main}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', height: 50}}>
                            <img src={item.img} width={46} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                            <Typography sx={{fontWeight: 600, textAlign: 'center'}}>{item.nombre}</Typography>
                        </Grid>

                    </Grid>
                )
            })}


        </Grid>
    )

}
export default Barra_Servicios

const items = [
    {
        img: ic_bano,
        nombre: 'Baño Privado'
    },
    {
        img: ic_tv,
        nombre: 'TV Moderno'
    },
    {
        img: ic_wifi,
        nombre: 'Wifi'
    },
    {
        img: ic_par,
        nombre: 'Parqueadero'
    },
    {
        img: ic_res,
        nombre: 'Restaurante'
    },
    {
        img: ic_aire,
        nombre: 'Aire Acondicionado'
    },
]